import { render, staticRenderFns } from "./ListRequesttipoPage.vue?vue&type=template&id=70686c96"
import script from "./ListRequesttipoPage.vue?vue&type=script&lang=js"
export * from "./ListRequesttipoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports